module.exports = "<div class=\"play-wrapper\" data-poster></div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/poster/public/poster.html
 ** module id = 144
 ** module chunks = 0
 **/